export default {
  login: "auth/login",
  signup: "auth/signup",
  logout: "auth/logout",
  company: "company",
};
